import { call, put } from 'typed-redux-saga';

import {
    DTMF_COMMANDS,
    dtmfCloseDebugMenuSaga,
    dtmfDebugMenuHaltSaga,
    dtmfDebugMenuToggleDrawingSaga,
    dtmfOpenDebugMenuSaga,
} from '../dtmf-commands';
import { BaseState } from './base-state';
import { StateId } from './types';

const DEBUG_MENU_STATE_TRANSITIONS: Record<string, StateId> = {
    [DTMF_COMMANDS.common.close]: 'command-list',
};

export class DebugMenuState extends BaseState {
    public id: StateId = 'debug-menu';

    public *process(command: string) {
        if (command === DTMF_COMMANDS.debug.halt) {
            yield* call(dtmfDebugMenuHaltSaga);
        }

        if (command === DTMF_COMMANDS.debug.drawConference.toggle) {
            yield* call(dtmfDebugMenuToggleDrawingSaga);
        }

        if (DEBUG_MENU_STATE_TRANSITIONS[command]) {
            yield* put(this.context.requestTransitionChannel, 'idle');
        }
    }

    public *onEnter() {
        yield* call(dtmfOpenDebugMenuSaga);
    }

    public *onExit() {
        yield* call(dtmfCloseDebugMenuSaga);
    }
}
